/* eslint-disable react/no-unknown-property */
import React from 'react';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosDiferenca.css';

function CarrosEletricosDiferenca() {
  return (
    <>
      <section id="carros-eletricos-diferenca">
        <Container>
          <h2 className="carros-eletricos-diferenca-title">
            Confira tudo que os <b>carros elétricos</b> proporcionam para o meio ambiente
          </h2>
          <div className="carros-eletricos-diferenca-cards-div">
            <div className="carros-eletricos-diferenca-card">
              <div className="carros-eletricos-diferenca-card-itens-div">
                <h4 className="carros-eletricos-diferenca-card-title">Veículo a combustão</h4>
                <ul className="carros-eletricos-diferenca-card-itens">
                  <li className="carros-eletricos-diferenca-card-item">
                    Mais componentes derivados do petróleo;
                  </li>
                  <li className="carros-eletricos-diferenca-card-item">
                    Aumento na emissão de carbono;
                  </li>
                  <li className="carros-eletricos-diferenca-card-item">Manutenção frequente;</li>
                  <li className="carros-eletricos-diferenca-card-item">Poluição sonora.</li>
                </ul>
                <img
                  className="carros-eletricos-diferenca-card-img"
                  src="assets/carros-eletricos/car-escudo.svg"
                  alt=""
                />
                <img
                  className="carros-eletricos-diferenca-card-img-icon ic_gas_station"
                  src="assets/carros-eletricos/ic_gas_station.svg"
                  alt="estação de carregamento para veículos elétricos"
                />
              </div>
            </div>
            <div className="carros-eletricos-diferenca-card">
              <div className="carros-eletricos-diferenca-card-itens-div">
                <h4 className="carros-eletricos-diferenca-card-title">Veículo elétrico</h4>
                <ul className="carros-eletricos-diferenca-card-itens">
                  <li className="carros-eletricos-diferenca-card-item">
                    Possibilidade de usar <b>energia renovável</b>;
                  </li>
                  <li className="carros-eletricos-diferenca-card-item">
                    Menos componentes derivados do petróleo;
                  </li>
                  <li className="carros-eletricos-diferenca-card-item">
                    Reduzir as chamadas ilhas de calor;
                  </li>
                  <li className="carros-eletricos-diferenca-card-item">
                    Baixa emissão <br className="only-mobi" />
                    de carbono.
                  </li>
                </ul>
                <img
                  className="carros-eletricos-diferenca-card-img"
                  src="assets/carros-eletricos/car-escudo.svg"
                  alt=""
                />
                <img
                  className="carros-eletricos-diferenca-card-img-icon ic_eletric_damage"
                  src="assets/carros-eletricos/ic_eletric_damage_2.svg"
                  alt="bateria para veículo elétrico"
                />
              </div>
            </div>
          </div>
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosDiferenca;
